<template>
  <div>
    <v-data-table
      id="fec-table"
      :headers="fecHeaders"
      :items="currentElectionData.sort((a, b) => b.totalRaised - a.totalRaised)"
      hide-default-footer
      mobile-breakpoint="null">
      <template v-slot:body="{ items }">
        <tr v-for="(item, index) in items" :key="index">
          <td>
            <a :href="item.fecUrl" target="_blank">
              {{ item.name }}
            </a>
            ({{ item.party }})
          </td>
          <td>{{ item.cashOnHand | money }}</td>
          <td>{{ item.totalRaised | money }}</td>
          <td>{{ item.totalSpent | money }}</td>
          <td>{{ item.report }}</td>
          <td>{{ ($options.filters.datetime(item.reportDate)).split(',')[0] }}</td>
          <!-- <td>{{ item.indExpSupport | money }}</td>
          <td>{{ item.indExpOppose | money }}</td> -->
        </tr>
      </template>
    </v-data-table>
    <div style="font-size: 12px; margin-top: 5px;">IE = Independent Expenditures, CoH = Cash on Hand</div>
    <!-- <div class="last-updated">Last Updated: {{ election.dateModified | datetime }}</div> -->
  </div>
</template>

<script>
const props = {
  electionJson: {
    type: Object,
    required: true
  }
}

const computed = {
  currentElectionData () {
    const election = this.electionJson.currentElection
    return Object.values(election).filter(item => item.name)
  }
}

export default {
  props,
  computed,
  data: () => ({
    fecHeaders: [
      { text: 'Candidate', value: 'candidate_name', width: '20%' },
      { text: 'CoH', value: 'cashOnHand' },
      { text: 'Contributions', value: 'totalRaised' },
      { text: 'Disbursements', value: 'totalSpent' },
      { text: 'Report', value: 'report' },
      { text: 'Date', value: 'date' }
      // { text: 'IE (Support)', value: 'indExpSupport' },
      // { text: 'IE (Oppose)', value: 'indExpOppose' }
    ]
  })
}
</script>

<style>
.theme--light.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon,
.dark--light.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon,
.theme--light.past-elections-table.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon,
.dark--light.past-elections-table.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
  display: none;
}
</style>
